export const fromTemplate = 'fromTemplate'
